<template>
  <v-flex class="pl-2">
    <v-layout
      row
      wrap>
      <v-flex
        xs12
        class="subheading mb-2">{{ $t('Note Type') }}:</v-flex>
      <v-flex
        xs12
        sm6>
        <v-radio-group
          v-model="noteType"
          :disabled="!product"
          row
          class="mt-0 pt-0"
          @change="adding = false"
        >
          <v-radio
            :disabled="!canAddSimpleNote"
            :label="$t('Simple')"
            value="simple"
          />
          <v-radio
            :disabled="!canAddLabeledNote"
            :label="$t('Labeled')"
            value="labeled"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        xs12
        sm6>
        <v-btn
          v-if="!adding"
          :disabled="!product"
          class="mt-0 pt-0"
          block
          small
          color="primary"
          @click="adding = true"
        >
          {{ $t('Add Note') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <template v-if="adding">
      <template v-if="noteType === 'simple'">
        <v-text-field
          v-model="simpleNote"
          :label="$t('Simple Note')"
          class="my-0 py-0"
        >
          <v-icon
            slot="prepend"
            medium
            @click="cancel"
          >
            close
          </v-icon>
          <v-icon
            slot="append-outer"
            medium
            @click="add"
          >
            check
          </v-icon>
        </v-text-field>
      </template>
      <template v-else>
        <v-text-field
          v-model="note.label"
          :label="$t('Label')"
          class="my-0 py-0"
        >
          <v-icon
            slot="prepend"
            medium
            @click="cancel"
          >
            close
          </v-icon>
          <v-icon
            slot="append-outer"
            medium
            @click="add"
          >
            check
          </v-icon>
        </v-text-field>
        <v-combobox
          v-model="note.values"
          :label="$t('Values')"
          class="combobox-size"
          return-object
          multiple
          small-chips
          deletable-chips
          outline
          append-icon=""
        />
      </template>
    </template>
  </v-flex>
</template>

<script>
export default {
  name: 'OrderDraftItemNote',

  props: {
    product: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      adding: false,
      noteType: 'simple',
      simpleNote: '',
      note: {
        label: '',
        values: []
      }
    }
  },

  computed: {
    canAddSimpleNote () {
      if (!this.product) {
        return false
      }

      return Array.isArray(this.product.notes) || !this.product.notes
    },

    canAddLabeledNote () {
      if (!this.product) {
        return false
      }

      if (Array.isArray(this.product.notes)) {
        return this.product.notes.length === 0
      }

      return !this.product.notes || typeof this.product.notes === 'object'
    }
  },

  mounted () {
    this.noteType = this.canAddSimpleNote ? 'simple' : 'labeled'
  },

  methods: {
    cancel () {
      this.adding = false
      this.simpleNote = ''
      this.note = {
        label: '',
        values: []
      }
    },

    add () {
      if (this.noteType === 'simple' && this.canAddSimpleNote) {
        this.addSimple()
      }

      if (this.noteType === 'labeled' && this.canAddLabeledNote) {
        this.addLabeled()
      }
    },

    addSimple () {
      if (!this.simpleNote) {
        return
      }

      if (!this.product.notes) {
        this.product.notes = []
      }

      this.product.notes = [...this.product.notes, ...[this.simpleNote]]
      this.adding = false
      this.simpleNote = ''
      this.$emit('note-added', this.product.notes)
    },

    addLabeled () {
      if (this.note.values.length === 0 || !this.note.label) {
        return
      }

      if (!this.product.notes || Array.isArray(this.product.notes)) {
        this.product.notes = {}
      }

      let notes = { ...this.product.notes }
      let values = this.note.values
      if (notes[this.note.label]) {
        values = [...notes[this.note.label], ...values]
      }

      notes[this.note.label] = values
      this.product.notes = { ...notes }
      this.adding = false
      this.note = {
        label: '',
        values: []
      }

      this.$emit('note-added', this.product.notes)
    }
  }
}
</script>

<style>
.combobox-size {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
</style>
